var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bars"},_vm._l((_vm.maxBarRpm),function(i){return _c('div',{key:i,staticClass:"bar",class:{
        active: _vm.getRPMBarActive(i),
        green: _vm.isAGreenBar(i),
        blue: _vm.isABlueBar(i),
        red: _vm.isARedBar(i)
      }})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }